import axios from '../axios'

const getListEventsApi = async (startTime, endTime) => {
  return await axios.get('api/teacher/events', {
    params: { startTime, endTime },
  })
}

export default getListEventsApi
